import axios from 'axios';

/**
 * Cliente axios para a API oficial da FIPE.
 * Base URL: https://veiculos.fipe.org.br/api/veiculos
 *
 * Todas as chamadas são POST com Content-Type application/json.
 * O header Referer é obrigatório para a FIPE aceitar a requisição.
 */
export const fipeClient = axios.create({
  baseURL: 'https://veiculos.fipe.org.br/api/veiculos',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Referer: 'https://veiculos.fipe.org.br/',
  },
});

/**
 * Cliente axios para a API Parallelum (fallback).
 * Base URL: https://fipe.parallelum.com.br/api/v2
 */
export const parallelumClient = axios.create({
  baseURL: 'https://fipe.parallelum.com.br/api/v2',
  timeout: 10000,
});

/**
 * Mapeamento do código de tipo de veículo interno
 * para o segmento de path da Parallelum.
 *
 * FIPE oficial:       1 = Carro, 2 = Moto, 3 = Caminhão
 * Sistema interno:    1 = Carro, 7 = Moto, 4 = Moto
 * Parallelum path:    cars | motorcycles | trucks
 *
 * @param {number|string} type — código de tipo do veículo (formato FIPE oficial)
 * @returns {string}
 */
export function getParallelumVehicleTypePath(type) {
  const map = {
    1: 'cars',
    2: 'motorcycles',
    3: 'trucks',
  };
  return map[Number(type)] || 'cars';
}

/**
 * Converte o tipo de veículo do sistema interno para o código da API oficial FIPE.
 *
 * Sistema interno:    1 = Carro, 7 = Moto, 4 = Moto
 * FIPE oficial:       1 = Carro, 2 = Moto, 3 = Caminhão
 *
 * @param {number|string} internalType
 * @returns {number}
 */
export function toFipeVehicleType(internalType) {
  const map = {
    1: 1, // Carro → Carro
    7: 2, // Moto (interno) → Moto (FIPE)
    4: 2, // Moto (interno) → Moto (FIPE)
  };
  return map[Number(internalType)] ?? Number(internalType);
}
